import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-compartir-web',
  templateUrl: './compartir-web.component.html',
  styleUrls: ['./compartir-web.component.scss'],
})
export class CompartirWebComponent implements OnInit {
  @Input() shareData:any = {};
  
  share = []

  constructor() { 
  }

  ngOnInit() {
    this.share.push(
      {
        icon: 'logo-whatsapp',
        social: 'WhatsApp',
        href: `https://api.whatsapp.com/send?text=${this.shareData.title} ${this.shareData.url}`
      },
      {
        icon: 'logo-twitter',
        social: 'Twitter',
        href: `https://twitter.com/intent/tweet?text=${this.shareData.title}&url=${this.shareData.url}`
      },
      {
        icon: 'logo-facebook',
        social: 'Facebook',
        href: `https://www.facebook.com/sharer/sharer.php?u=${this.shareData.url}`
      }
    )
  }

  compartir(social:string){
    window.open(social, '_blank');
  }
}
